import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { EditorApp } from "./EditorApp";
import "../styles/foundation.css";
import "../styles/missions.css";
import "../styles/expeditions.css";
import "../styles/expedition-overhaul.css";
import "../styles/pvp.css";
import "../styles/social.css";
import "../styles/neighbourhood.css";
import "../styles/production.css";
import "../styles/editor-overhaul.css";
import "../styles/editor-reference.css";
import "../styles/editor-parity.css";

const root = document.getElementById("root");
if (!root) throw new Error("Editor root element is missing.");

createRoot(root).render(<StrictMode><EditorApp /></StrictMode>);
